import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'evalFn'})
export class EvalFnPipe implements PipeTransform {
  transform(
    fn: (row?) => boolean,
    row: any
  ): boolean {
    return (fn) ? fn(row) : true;
  }
}
